import { create } from 'zustand';

/**
 * Type MIME custom du drag & drop sidebar → canvas (transporte l'uniqueCode
 * du commercial glissé). Partagé entre `HierarchySidebar` (source) et
 * `SalesHierarchyCanvas` (cible, via `TreeFlowCanvas`).
 */
export const HIERARCHY_SALE_DRAG_TYPE = 'application/x-fiddy-hierarchy-sale';

interface HierarchyCanvasState {
  /** uniqueCodes déjà présents sur le canvas (arbre + nœuds locaux non reliés) — la sidebar les exclut de sa liste. */
  placedUniqueCodes: Set<string>;
  setPlacedUniqueCodes: (uniqueCodes: Set<string>) => void;
}

/**
 * Sidebar et canvas sont frères dans l'arbre de composants (posés par
 * `Layout`, pas l'un dans l'autre) : ce store est le seul canal pour que la
 * sidebar sache quels commerciaux sont déjà posés sur le canvas.
 */
export const useHierarchyCanvasStore = create<HierarchyCanvasState>((set) => ({
  placedUniqueCodes: new Set(),
  setPlacedUniqueCodes: (uniqueCodes) => set({ placedUniqueCodes: uniqueCodes })
}));
